import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useEffect } from 'react'

import { useAuth } from '@/hooks/useAuth'
import { IdePage } from '@/pages/IdePage'
import { LoginPage } from '@/pages/LoginPage'
import { SetupPage } from '@/pages/SetupPage'
import arkitectLogo from '../assets/arkinavlogo.png'

function LoadingScreen() {
  return (
    <div className="app-loading">
      <div className="app-loading-logo">
        <img src={arkitectLogo} alt="Arkitect Logo" />
      </div>
      <div className="app-loading-spinner" />
      <span className="app-loading-text">Launching Arkitect Desktop...</span>
    </div>
  )
}

function RequireSetup({ children }) {
  const isSetupComplete = localStorage.getItem('arkitect_setup_completed') === 'true'
  if (!isSetupComplete) {
    return <Navigate to="/setup" replace />
  }
  return children
}

export default function App() {
  const { bootstrapping } = useAuth()

  if (bootstrapping) {
    return <LoadingScreen />
  }

  return (
    <>
      <div role="status" className="experimental-banner">
        Experimental desktop client — Arkitect project access does not require Electron.
      </div>
      <Routes>
        <Route path="/" element={<Navigate to="/ide" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/setup" element={<SetupPage />} />
        <Route
          path="/ide"
          element={
            <RequireSetup>
              <IdePage />
            </RequireSetup>
          }
        />
        <Route path="*" element={<Navigate to="/ide" replace />} />
      </Routes>
    </>
  )
}
